import gsap from "gsap";
import barba from "@barba/core";
import { select } from "../../utils";
import { state } from "../state";
import { openModalTracked, closeModalTracked } from "../modalTracker";

export const initUIEvents = (): void => {
  const controlsDialog = select(".controls__dialog");
  const controlsSpan = select("#controls");
  const controlsCloseBtn = select(".controls__dialog .close");
  const logo = select(".logo");
  const arrowBtn = select(".overlay__arrow");

  const onClickControls = () => {
    if (!controlsDialog) return;
    controlsDialog.style.display = "flex";
    gsap.to(controlsDialog, { duration: 0.3, opacity: 1 });
  };

  const onClickCloseControls = () => {
    if (!controlsDialog) return;
    gsap.to(controlsDialog, {
      duration: 0.3,
      opacity: 0,
      onComplete: () => {
        controlsDialog.style.display = "none";
      },
    });
  };

  if (controlsCloseBtn) controlsCloseBtn.onclick = onClickCloseControls;
  if (controlsSpan) controlsSpan.onclick = onClickControls;

  if (arrowBtn) {
    arrowBtn.onclick = () => {
      const modalElement = document.querySelector(
        ".overlay__modal",
      ) as HTMLElement | null;
      const isVisible =
        modalElement &&
        (modalElement.style.display === "block" ||
          modalElement.style.transform === "translateX(0)");

      if (isVisible && state.isModalOpen) {
        closeModalTracked();
      } else if (state.lastModalArgs) {
        openModalTracked(
          state.lastModalArgs.elName,
          state.lastModalArgs.options,
        );
      }
    };
  }

  const backBtns = document.querySelectorAll(".back");
  backBtns.forEach((btn) => {
    (btn as HTMLElement).onclick = (e) => {
      e.preventDefault();
      const hasHistory = window.history.length > 1;
      const isSameHost =
        !document.referrer || document.referrer.includes(window.location.host);

      if (hasHistory && isSameHost) {
        window.history.back();
      } else {
        barba.go("index.html");
      }
    };
  });

  if (logo) {
    logo.onclick = (e) => {
      if (state.map) {
        e.preventDefault();
        state.map.animateTo(
          { center: [0, 0], zoom: 3 },
          { duration: 800, easing: "out" },
        );
      }
    };
  }
};
